import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MyCampaignPageComponent as MyCampaignPageComponent } from './pages/my-campaign-page.component';

const routes: Routes = [{
  path: '',
  component: MyCampaignPageComponent,
}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MyCampaignRoutingModule { }
